export default "__VITE_ASSET__eT5lGzwH__"